import React, {createContext, useEffect, useMemo} from 'react';
import CustomHeader from '../baseComponents/gui/customHeader/CustomHeader';
import Footer from '../baseComponents/gui/footer/Footer';
import {node} from "prop-types";
import ModalProvider from "../baseComponents/controllers/modalController/ModalProvider";
import Head from "next/head";
import {hrefFix} from "../../utils/hrefFix";
import {usePanel} from "../../redux/reducer/panel";
import Script from "next/script";
import setAnalyticsElements from "../../utils/analytics/setAnalyticsElements";
import {getAnalytics} from "../../utils/analytics/getAnalytics";
import {saveData} from "../../utils/data/saveData";
import dynamic from "next/dynamic";
import stylesCH from "../../components/baseComponents/gui/customHeader/CustomHeader.module.scss";
import classNames from "classnames";
import styles from "./MainLayout.module.scss";

const NarrativesModal = dynamic(() => import('../narrativesModal/NarrativesModal'), {ssr: false});
const LogoutModal = dynamic(() => import('../logoutModal/LogoutModal'), {ssr: false});
const SearchModal = dynamic(() => import('../searchModal/SearchModal'), {ssr: false});
const Authorization = dynamic(() => import('../authorization/Authorization'), {ssr: false});
const Search = dynamic(() => import('../search/Search'), {
  ssr: false
});
export const BreadcrumbsContext = createContext(null);

export default function MainLayout({children, analytic, data}) {

  const {analytics, elements} = analytic ?? {};
  const {burger} = usePanel();

  const analyticsData = useMemo(
    () => getAnalytics(analytics),
    [analytics]
  );

  const breadcrumbs = useMemo(
    () => saveData(data),
    [data]
  );

  useEffect(() => {
    hrefFix();
  }, []);

  useEffect(() => {
    if (!elements || !elements.length) return;

    const cleanup = setAnalyticsElements(elements);

    return () => {
      if (typeof cleanup === "function") cleanup();
    };
  }, [elements]);


  return (
    <>
      <Head>
        {analyticsData.head}
      </Head>
      <BreadcrumbsContext.Provider value={breadcrumbs}>
        <ModalProvider
          aliases={useMemo(() => ({
            narrativesModal: {Modal: NarrativesModal, props: {}},
            logoutModal: {Modal: LogoutModal, props: {}},
            searchModal: {Modal: SearchModal, props: {}},
            authorizationModal: {Modal: Authorization, props: {}}
            // infoModal: {Modal: InfoModal, props: {message: "Lorem ipsum"}}
          }), [])}
        >
          {analyticsData.body}
          <input type={"checkbox"}
                 className={classNames("custom-header__input", stylesCH.customHeader__input)}
                 id={"menu-burger"}
                 checked={burger}
                 value={burger}
                 readOnly={true}/>
          <div className={classNames('main-container', styles.mainContainer)}>
            <CustomHeader {...data?.header}>
              <Search/>
              {/*-<Profile/>*/}
            </CustomHeader>
            <main className={'content-wrapper'}>{children}</main>
            <Footer/>
          </div>
        </ModalProvider>
      </BreadcrumbsContext.Provider>
    </>
  )
}

MainLayout.propTypes = {
  children: node,
};
